"use client";

import { DownloadCard } from "@/components/marketing/download-card";
import {
  FREE_TEMPLATE_CATALOG,
  freeTemplateHref,
  type FreeTemplateId,
} from "@/lib/marketing/free-template-catalog";
import { FREE_TEMPLATE_FILE_BYTES } from "@/lib/marketing/free-template-file-sizes.generated";

/**
 * The blank, ungated template download on a /free/* template page (SEO plan
 * row 15): a PDF to print and a Word file to edit, both generated by
 * scripts/generate-free-templates.ts. The page keeps its "create it for your
 * job" call to action as the upgrade.
 */
export function BlankTemplateDownload({
  template,
  source,
}: {
  template: FreeTemplateId;
  /** PostHog `source`, e.g. "free_coshh_template". */
  source: string;
}) {
  const { label, includes } = FREE_TEMPLATE_CATALOG[template];
  const bytes = FREE_TEMPLATE_FILE_BYTES[template];
  const analytics = { source, document: template, kind: "blank_template" } as const;

  return (
    <DownloadCard
      heading={`Download a blank ${label} template`}
      description="Free, no sign-up. Print the PDF and fill it in by hand, or fill in the Word file on a computer."
      note={includes}
      links={[
        {
          href: freeTemplateHref(template, "pdf"),
          label: "Download PDF",
          bytes: bytes.pdf,
          primary: true,
          analytics: { ...analytics, format: "pdf" },
        },
        {
          href: freeTemplateHref(template, "docx"),
          label: "Download Word (.docx)",
          bytes: bytes.docx,
          analytics: { ...analytics, format: "docx" },
        },
      ]}
    />
  );
}
